import { Component, Input } from '@angular/core';
import { RouteTreeChartNodeDto } from '../RouteTreeChartNodeDto';

@Component({
  selector: 'shared-route-chart-box',
  templateUrl: './shared.route.chart.box.component.html',
  styleUrls: ['./shared.route.chart.box.component.scss'],
})
export class SharedRouteChartBoxComponent {

  public __value: RouteTreeChartNodeDto;
  @Input()
  public set value(value: RouteTreeChartNodeDto) {
    if (this.__value === value)
      return;
    this.__value = value;
    this.wellCome();
  }
  public get value(): RouteTreeChartNodeDto {
    return this.__value;
  }

  public caption: string = "PARTNER.TITLE";


  public wellCome() {
    if (this.value && this.value.type)
      this.caption = "PARTNER." + this.value.type.toUpperCase() + ".TITLE";
  }

  public pretty(value) {
    return JSON.stringify(value);
  }
}
